import { cn } from "@/lib/utils";
import { GroupPosition } from "./groupPosition";

interface GroupConnectorProps {
  position: GroupPosition;
}

export function GroupConnector({ position }: GroupConnectorProps) {
  if (position === GroupPosition.None) {
    return null;
  }

  return (
    <div
      aria-hidden
      className={cn(
        "absolute left-0 w-1 bg-primary",
        position === GroupPosition.Start && "top-0 -bottom-2 rounded-tl-lg",
        position === GroupPosition.Middle && "top-0 -bottom-2",
        position === GroupPosition.End && "top-0 bottom-0 rounded-bl-lg",
      )}
    />
  );
}
